<template lang="pug">
  .custom-file
    input#file-uploader.custom-file-input(type='file', data-target='file-uploader', @change='handleFileUpload')
    button.custom-file-label.popup-label--mobile(for='customFile')
</template>

<script>
export default {
  name: 'ButtonUploadImage',

  data () {
    return {
      fileName: '',
      imageUrl: ''
    }
  },
  methods: {
     async handleFileUpload(e) {
      try {
        const file = e.target.files[0];
        this.$emit('setUploading', true)
        if (!file) return;

        const beforeUploadCheck = await this.beforeUpload(file);
        if (!beforeUploadCheck.isValid) throw beforeUploadCheck.errorMessages;

        const arrayBuffer = await this.getArrayBuffer(file);
        await this.uploadFileAJAX(arrayBuffer);
        this.extractImageUrl(file);
        this.$emit("setImageUrl", this.imageUrl);
        this.$emit("setThumbnailPreview", this.imageUrl);
        this.$emit("setImageFileName", this.fileName);
        this.$emit("setImageFile", file) 
        this.$emit('setImageUploaded', true)
      } catch (error) {
        alert(error);
      } finally {
        e.target.value = '';  // reset input file
        this.$emit('setUploading', false)        
      }
    },
    // STEP 2: showPreviewImage with createObjectURL
    // If you prefer Base64 image, use "FileReader.readAsDataURL"
    extractImageUrl(fileObj) {
      const image = URL.createObjectURL(fileObj);
      this.fileName =  fileObj.name
      this.imageUrl = image
    },

    // STEP 3: change file object into ArrayBuffer
    getArrayBuffer(fileObj) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        // Get ArrayBuffer when FileReader on load
        reader.addEventListener("load", () => {
          resolve(reader.result);
        });

        // Get Error when FileReader on error
        reader.addEventListener("error", () => {
          reject("error occurred in getArrayBuffer");
        });

        // read the blob object as ArrayBuffer
        // if you nedd Base64, use reader.readAsDataURL
        reader.readAsArrayBuffer(fileObj);
      });
    },

    // STEP 4: upload file throguth AJAX
    // - use "new Uint8Array()"" to change ArrayBuffer into TypedArray
    // - TypedArray is not a truely Array,
    //   use "Array.from()" to change it into Array
    uploadFileAJAX(arrayBuffer) {
      // correct it to your own API endpoint
      return fetch("https://jsonplaceholder.typicode.com/posts/", {
        headers: {
          version: 1,
          "content-type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
          imageId: 1,
          icon: Array.from(new Uint8Array(arrayBuffer))
        })
      })
      .then(res => {
        if (!res.ok) {
          throw res.statusText;
        }
        return res.json();
      })
      .then(data => data)
      .catch(err => {
        /* eslint-disable */
        console.log("err", err)
      });
    },

    // STEP 5: Create before upload checker if needed
    beforeUpload(fileObject) {
      return new Promise(resolve => {
        const validFileTypes = ["image/jpeg", "image/png"];
        const isValidFileType = validFileTypes.includes(fileObject.type);
        let errorMessages = [];

        if (!isValidFileType) {
          errorMessages.push("You can only upload JPG or PNG file!");
        }

        const isValidFileSize = fileObject.size / 1024 / 1024 < 5;
        if (!isValidFileSize) {
          errorMessages.push("Image must smaller than 5MB!");
        }

        resolve({
          isValid: isValidFileType && isValidFileSize,
          errorMessages: errorMessages.join("\n")
        });
      });
    },
  }
}
</script>
<style scoped src="./button_upload_image.vue.css"></style>